import { isEqual } from "es-toolkit"
import { useFormState } from "react-final-form"

export enum FormChangeState {
	DIRTY = 0,
	ERROR = 1,
	NOT_DIRTY = 2,
	SAVED = 3,
}

const lazyCatch = <R>(fn: () => R): R | undefined => {
	try {
		return fn()
	} catch {}
	return undefined
}

export function useFormChangeState(enable = true): FormChangeState {
	const formState = lazyCatch(useFormState) // Ignore the error when the component is not wrapped into a `Form`.
	if (!(enable && formState)) return FormChangeState.NOT_DIRTY

	if (formState.modifiedSinceLastSubmit) return FormChangeState.DIRTY
	if (formState.submitSucceeded) return FormChangeState.SAVED
	// dirty is actually true if the form was touched, even if the values are the same as initialValues

	const isDirty = !isEqual(formState.initialValues, formState.values)
	if (formState.pristine) return FormChangeState.NOT_DIRTY
	if (formState.submitError) return FormChangeState.ERROR
	if (isDirty) return FormChangeState.DIRTY

	return FormChangeState.NOT_DIRTY
}
